import { Component, Inject, OnInit } from "@angular/core";
import { FormGroup } from "@angular/forms";
import { MAT_DIALOG_DATA } from "@angular/material/dialog";
import {
  ObjectFrom
} from "../../dynamic-form/models/input-form";
import { DynamicFormServices } from "../../dynamic-form/services/dynamic-form.services";
import { MyUtils } from "src/app/services/my-utils.service";
import { cloneDeep } from "lodash";
import { Observable, forkJoin, from, of } from "rxjs";

export interface ConfirmDialogData {
  title: string;
  message: string;
  uploadFile?: boolean
  inputForm: ObjectFrom[];
  confirmButtonText?: string;
  confirmButtonColor?: "primary" | "warn" | "accent";
}

@Component({
  selector: "app-confirm-dialog",
  templateUrl: "./confirm-dialog.component.html",
  styleUrls: ["./confirm-dialog.component.scss"],
})
export class ConfirmDialogComponent implements OnInit {
  formGroup: FormGroup;
  file: File[] = [];
  fileB64?: string;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: ConfirmDialogData,
    private dynamicFormService: DynamicFormServices,
    public utils: MyUtils
  ) {
    this.formGroup = this.dynamicFormService.generateFormGroup(data.inputForm);
  }

  ngOnInit(): void { }

  incomingfile(event: any) {

    let file = event.target.files[0] as File;
    this.file.push(event.target.files[0] as File);
  }

  deleteFile(i: number) {
    let files: any = []
    this.file.forEach((el: any, j: number) => {
      if (i !== j)
        files.push(el)
    })

    this.file = cloneDeep(files);
    this.fileB64 = undefined;

  }

  sizeError(i: number) {
    return this.file ? this.file[i].size > 16 * Math.pow(10, 6) : false;
  }

  returnValueDialog() {
    if (this.data.uploadFile) {
      let newValue: any = {};
      newValue = this.formGroup.value;

      let b64F$: Observable<string | undefined>[] = []
      this.file.forEach(item => {
        let b64P = item ? this.getBase64(item) : of(undefined)
        b64F$.push(from(b64P))
      })

      forkJoin(b64F$).subscribe(data => {
        (data)
        let attachments: any = []
        data.forEach((d: any, i: number) => {
          attachments.push({
            file: d,
            type: this.file[i].type
          })
        })
        newValue.attachments = attachments
        // this.attach(attachments);
      })



      // newValue.attachments = this.file.map(file => ({
      //   file: file,
      //   type: file.type
      // }));
      return newValue;
    } else {
      return this.formGroup.value;
    }
  }

  private getBase64(file: Blob): Promise<string> {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => {
        let b64 = reader.result as string;
        let ix = b64.indexOf(";base64,");
        if (ix >= 0) {
          let substr = b64.substring(ix);
          let data = substr.replace(";base64,", "");
          return resolve(data);
        } else {
          resolve(reader.result as string);
        }
      };
      reader.onerror = (error) => reject(error);
    });
  }

}
